import React, { useCallback, useEffect, useRef } from 'react';

export default function usePreventVerticalScroll<T extends HTMLElement>(
  ref: React.RefObject<T | null>,
  dragThreshold = 5
) {
  const firstClientX = useRef(0);
  const clientX = useRef(0);

  const preventTouch = useCallback(
    (e: TouchEvent) => {
      clientX.current = e.touches[0].clientX - firstClientX.current;
      if (Math.abs(clientX.current) > dragThreshold && e.cancelable) {
        e.preventDefault();

        return false;
      }

      return true;
    },
    [dragThreshold]
  );

  const touchStart = useCallback((e: TouchEvent) => {
    firstClientX.current = e.touches[0].clientX;
  }, []);

  useEffect(() => {
    const current = ref.current;
    if (current) {
      current.addEventListener('touchstart', touchStart);
      current.addEventListener('touchmove', preventTouch, { passive: false });
    }

    return () => {
      if (current) {
        current.removeEventListener('touchstart', touchStart);
        current.removeEventListener('touchmove', preventTouch);
      }
    };
  }, [preventTouch, ref, touchStart]);
}
